<div class="mobileHeaderContainer d-block d-md-none">
  <div class="mobile-header">
    <div class="contactInfo d-flex justify-content-end align-items-center">
      <div class="support-container">
        <span class="customerCareCallBuy toggle-section">
          <a href="tel:9999933039" class="content">
            <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl+'/assets/images/contact-us/call-wht.png'" alt="Phone | Luminous">
            <span class="me-2">Customer Care:</span>
            <span class="fw-bold">
              +91-9999933039
            </span>
          </a>
          <a (click)="analyticsService.triggerSupportContactEvent(8906008008,'Call & Buy')" href="tel:8906008008" class="content-box">
            <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl+'/assets/images/contact-us/call-wht.png'" alt="Phone | Luminous">
            <span class="me-2">Call & Buy :</span>
            <span class="fw-bold">
              +91-8906008008
            </span>
          </a>
        </span>
        <span class="solarSolutions toggle-section d-flex justify-content-center flex-column">
          <div class="w-100 d-flex justify-content-center">
            <a href="tel:9990299902" class="me-2 content">
              <img height="20" width="20" class="me-2" loading="lazy"
                [src]="environment?.blobUrl + '/assets/images/contact-us/call-wht.png'" alt="Phone | Luminous">
              <!-- <img height="20" width="20" class="me-2" loading="lazy"
                [src]="environment?.blobUrl + '/assets/icons/whatsapp-white.svg'" alt="Phone | Luminous"> -->
              <span class="me-2">Energy Solutions:</span>
              <span class="fw-bold">9990299902</span>
            </a>
          </div>
          <a href="mailto:energysolution@luminousindia.com" class="content-box">
            <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl+'/assets/icons/mail-white.svg'" alt="Email | Luminous">
            <span class="fw-bold normal">
              energysolution&#64;luminousindia.com
            </span>
          </a>
        </span>
      </div>
    </div>
    <div class="mobilemainHeader">
      <div class="logoContainer">
        <img width="24" height="24" class="hamburger"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/hamburger.svg'" alt="Hamburger | Luminous"
          (click)="navBarHandler(true)">
        <img height="148" width="35" class="logo w-auto" routerLink="/"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/LuminousLogoBlue.webp'"
          alt="Logo | Luminous">
        <div>
          <img #searchIconHeader class="searchIcon" [ngClass]="{'showSearchIcon': !showSearchBar}"
           loading="lazy" [src]="environment?.blobUrl+'/assets/icons/searchBlack.svg'" (click)="openSearchBar(true)" alt="Search | Luminous">
          <span class="position-relative" routerLink="/cart-details">
            <img class="cart" (click)="trackCartViewed()"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/cart.svg'"
              alt="Cart Image | Luminous">
            <!-- <span *ngIf="service.cartData$ | async as cartInfo" class="item-number">{{cartInfo.length || ''}}</span> -->
          </span>
        </div>
      </div>
      <div class="searchBarContainer" *ngIf="!hideSearch" [ngClass]="{'showSearchBar': showSearchBar}">
        <div class="mobileSearchBar">
          <img width="24" height="21" class="searchIcon"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/search.svg'" alt="Search| Luminous">
          <form (ngSubmit)="onEnter($event)">
            <input type="text" placeholder="Search for a product" (click)="getRecentlySearched()" aria-label="Number"
              matInput [formControl]="myControl" [matAutocomplete]="auto">
            <button hidden type="submit"></button>
          </form>
          <img width="12" height="12" *ngIf="myControl.value" class="closeIcon"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'"
            alt="Cancel | Luminous" (click)="clearSearch()">
        </div>
        <ng-container *ngIf="searchResults?.length">
          <div class="search-results">
            <ul>
              <li *ngFor="let result of searchResults" (click)="onSearchClick(true)">{{ result?.productName }}</li>
            </ul>
          </div>
        </ng-container>
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let option of recentlySearchList" [value]="option?.searchedText">
            <img width="12" height="12"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/clock.webp'" alt="Clock Icon | Luminous">
            {{option?.searchedText}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </div>

  <mat-sidenav-container class="navBar" [ngClass]="{'navBarOpen' : sidenavOpen && utils.screenSizeObj.width < 1000}">
    <mat-sidenav #sidenav disableClose>
      <div class="navBarUpper">
        <div class="navBarLogoContainer">
          <img loading="lazy" height="148" width="35" class="logo w-auto" [src]="environment?.blobUrl+'/assets/icons/LuminousLogoBlue.webp'" alt="Logo | Luminous">
          <button class="navCloseBtn" (click)="navBarHandler(false)">Close
            <span class="icon">x</span>
          </button>
        </div>
        <div class="navBarMiddleContainer">
          <div class="categoriesContainer" *ngIf="!utils.selectedCategory.landingPageGuid">
            <div class="categories" *ngFor="let categoryData of menuList;let i=index"
              (click)="categoryHandler(i,categoryData)">
              <div class="mainCategory">
                <img loading="lazy" [src]="categoryData.inActiveFeatureIconFile" [alt]="categoryData.featureAltTag">
                <p>
                  {{categoryData.category}}
                </p>
              </div>
              <div class="arrowIcon"></div>
            </div>

            <div class="categories" *ngFor="let staticData of navBarStaticData;let i=index"
              [ngClass]="{'noBottomBorder':!isLogIn,'marginTop25':i==0, 'border-0': (i == 0 && isLogIn)}">
              <div class="mainCategory profile-side-bar" *ngIf="i==1 && isLogIn">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-description>
                        <img loading="lazy" [src]="staticData.icon" alt={{staticData.icon}}>
                        <p>
                          {{staticData.title}}
                        </p>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class=" ">
                      <app-profile-sidebar [notShowActiveClass]="false" [hideLogoutButton]="true"
                        (routeSet)="navBarHandler(false)">
                      </app-profile-sidebar>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div class="mainCategory" [hidden]="(i == 1 && (!isLogIn || isLogIn)) || (i == 0 && isLogIn)">
                <img loading="lazy" [src]="staticData.icon" alt={{staticData.icon}}>
                <p (click)="redirectToPath(staticData.link)">
                  {{staticData.title}}
                </p>
              </div>
            </div>
            <div class="mainCategory" *ngIf="isLogIn">
              <img loading="lazy" [src]="environment?.blobUrl+'/assets/icons/signOut.svg'" alt="Sign Out | Luminous">
              <p *ngIf="isLogIn" (click)="logout()">
                Sign out
              </p>
            </div>
          </div>
          <div class="subCategoryContainer" [ngClass]="{'subCategoryShowing': utils.selectedCategory.landingPageGuid}"
            *ngIf=" utils.selectedCategory.landingPageGuid">
            <div class="categories noBorder">
              <div class="mainCategory" (click)="backBtnHandler()">
                <div class="back_arrowIcon"></div>
                <p>
                  Back
                </p>
              </div>
            </div>
            <div class="categories">
              <div class="mainCategory selectedCategory">
                <img loading="lazy" [src]="utils.selectedCategory.activeFeatureIconFile" [alt]="utils.selectedCategory.featureAltTag">
                <a [routerLink]="getCategoryRouteLink(utils.selectedCategory)"
                  (click)="categoryCLickHandler(utils.selectedCategory)">
                  {{utils.selectedCategory.category}}
                </a>
              </div>
            </div>
            <mat-accordion>
              <div *ngFor="let subData of utils.selectedSubCategory;let subIndex=index"
                [ngClass]="{'subCatSelected':subIndex == utils.subCatOpenIndex}">
                <mat-expansion-panel (opened)="panelStateHandler(subIndex,true)"
                  (closed)="panelStateHandler(subIndex,false)">
                  <mat-expansion-panel-header>
                    <mat-panel-description>
                      <div class="mainCategory">
                        <a class="text-transform-none" [routerLink]="getSubCatRouteLink(subData)"
                          (click)="subCatHandler(utils.selectedCategory,subData)">
                          {{subData.subCategory}}
                        </a>
                      </div>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class=" ">
                    <div class="accordianData">
                      <div class="mb-3" *ngFor="let subSubCat of subData.brandSubSubCategoriesMenu"
                        [hidden]="!utils.checkValidityOfGuid(subSubCat.landingPageGuidId)">
                        <a class="mb-3 strong minorSubCat text-transform-none"
                          [routerLink]="minorSubCatHandler(subSubCat)"
                          (click)="navBarHandler(false)">{{subSubCat.name}}</a>
                        <ul class="ps-3">
                          <li class="pb-2" *ngFor="let subCatSeries of subSubCat.series">
                            <a class="text-transform-none" [routerLink]="getSeriesRouteLink(utils.selectedCategory,subData,subCatSeries)"
                              (click)="seriesNavHandler(utils.selectedCategory,subData,subCatSeries)">
                              {{subCatSeries.series}}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div class="mb-3" *ngFor="let seriesData of subData?.series">
                        <a class="text-transform-none" [routerLink]="getSeriesRouteLink(utils.selectedCategory,subData,seriesData)"
                          (click)="seriesNavHandler(utils.selectedCategory,subData,seriesData)">
                          {{seriesData.series}}
                        </a>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            </mat-accordion>
          </div>
        </div>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
<!-- header for size greater then 1000 -->
<div class="mainHeader d-none d-md-block">
  <div>
    <div [class.hide-contact-info]="!showContactInfo" class="contactInfo d-flex justify-content-end align-items-center">
      <div class="scrolling-container d-flex justify-content-center align-items-center">
        <span class="scrolling-text">
          <a [routerLink]="['/shop-now']"> Use <b>WELCOME250</b> to get flat ₹250 off on your 1st order! </a>
        </span>
      </div>
      <div class="support-container">
        <span class="customerCareCallBuy toggle-section">
          <a href="tel:9999933039" class="content">
            <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl+'/assets/images/contact-us/call-wht.png'" alt="Phone | Luminous">
            <span class="me-2">Customer Care :</span>
            <span class="fw-bold">
              +91-9999933039
            </span>
          </a>
          <a (click)="analyticsService.triggerSupportContactEvent(8906008008,'Call & Buy')" href="tel:8906008008" class="content-box">
            <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl+'/assets/images/contact-us/call-wht.png'" alt="Phone | Luminous">
            <span class="me-2 box">Call & Buy :
              <span class="fw-bold">
                +91-8906008008
              </span>
            </span>
          </a>
        </span>
        <span class="solarSolutions toggle-section d-flex">
          <a href="tel:9990299902" class="solar-text content">
            <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl + '/assets/images/contact-us/call-wht.png'" alt="Phone | Luminous">
            <!-- <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl + '/assets/icons/whatsapp-white.svg'" alt="Phone | Luminous"> -->
            <span class="me-2">Energy Solutions:</span>
            <span class="fw-bold">9990299902</span>
          </a>
          <a href="mailto:energysolution@luminousindia.com" class="content-box">
            <img height="20" width="20" class="me-2" loading="lazy"
              [src]="environment?.blobUrl+'/assets/icons/mail-white.svg'" alt="Email | Luminous">
            <span class="fw-bold normal box">
              energysolution&#64;luminousindia.com
            </span>
          </a>
        </span>
      </div>
        <a href="/ecom-distributor" class="ecom-btn">Become an <span class="fw-bold">ECOM</span> Distributor</a>
    </div>
  </div>
  <div>
    <div class="middleContainer">
      <div class="leftContainer">
        <a routerLink="/" class="logo"><img loading="lazy" height="148" width="35" class="w-auto"
            [src]="environment?.blobUrl+'/assets/icons/LuminousLogoBlue.webp'" alt="Logo | Luminous"></a>
        <!-- <div *ngIf="menuList && menuList.length"> -->
        <div class="subCatContainerMain d-flex justify-content-end" *ngIf="menuList">
          <div class="subCatContainer" *ngFor="let categoryData of menuList;let i=index">
            <a class="heading5 mainCatTitle" [ngClass]="{'noArrowAfter':!categoryData.brandSubCategoriesMenus.length}"
              [routerLink]="getCategoryRouteLink(categoryData)"
              (click)="categoryCLickHandler(categoryData)">{{categoryData.category}}</a>
            <div class="subCat" *ngIf="categoryData.brandSubCategoriesMenus.length"
              [ngClass]="checkWidth(categoryData.brandSubCategoriesMenus)">
              <div class="row">
                <div class="menu-col"
                  [ngClass]="{'col-md-3':(categoryData.brandSubCategoriesMenus.length >= 6) , 'col-md-4':(categoryData.brandSubCategoriesMenus.length < 6)}"
                  *ngFor="let subCatData of categoryData.brandSubCategoriesMenus">
                  <p class="heading5">
                    <a class="text-transform-none" [routerLink]="getSubCatRouteLink(subCatData)"
                      (click)="subCatHandler(categoryData,subCatData)">
                      {{subCatData.subCategory}}
                    </a>
                  </p>
                  <ul class="minorCat">
                    <li class="no-sub-category" *ngFor="let seriesData of subCatData?.series">
                        <a class="text-transform-none" [routerLink]="getSeriesRouteLink(categoryData,subCatData,seriesData)"
                        (click)="seriesNavHandler(categoryData,subCatData,seriesData)">
                        {{seriesData.series}}
                      </a>
                    </li>
                    <li *ngFor="let subSubCat of subCatData?.brandSubSubCategoriesMenu"
                      [hidden]="!utils.checkValidityOfGuid(subSubCat.landingPageGuidId)">
                      <a class="minorSubCat text-transform-none" [routerLink]="minorSubCatHandler(subSubCat)"
                        (click)="navBarHandler(false)">{{subSubCat.name}}</a>
                      <ul class="ps-2 pt-2">
                        <li *ngFor="let subCatSeries of subSubCat.series">
                            <a class="text-transform-none" [routerLink]="getSeriesRouteLink(categoryData,subCatData,subCatSeries)"
                            (click)="seriesNavHandler(categoryData,subCatData,subCatSeries)">
                            {{subCatSeries.series}}
                          </a>
                        </li>
                      </ul>
                    </li>

                    <!-- <li class="no-sub-category" *ngFor="let seriesData of subCatData.series"
                        (click)="seriesNavHandler(categoryData,subCatData,seriesData)">
                        {{seriesData.series}}
                      </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <div class="rightContainer">
        <div class="searchBar" *ngIf="removeSearch">
          <img width="21" height="21" class="searchIcon"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/search.svg'" alt="Search | Luminous">
          <input type="text" placeholder="Search for a product" aria-label="Number" matInput [formControl]="myControl"
            [matAutocomplete]="auto" (keypress)="onEnter($event)" (click)="getRecentlySearched()"
            (focus)="getRecentlySearched()">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of recentlySearchList" [value]="option?.searchedText"
              (click)="onSearchClick()">
              <img loading="lazy" width="12" height="12" [src]="environment?.blobUrl+'/assets/icons/clock.webp'" alt="Clock Icon | Luminous">
              {{option?.searchedText}}
            </mat-option>
          </mat-autocomplete>
          <img loading="lazy" width="12" height="12" *ngIf="myControl.value" class="closeIcon"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'"
            alt="Cancel | Luminous" (click)="clearSearch()">
        </div>
        <ng-container *ngIf="searchResults?.length">
          <div class="search-results">
            <ul>
              <li *ngFor="let result of searchResults" (click)="onSearchClick(true)">{{ result?.productName }}</li>
            </ul>
        </div>
        </ng-container>
        <div class="iconContainer ms-auto">
          <div class="icon-col user-profile">
            <img loading="lazy" width="21" height="21" class="userImg" [src]="environment?.blobUrl+'/assets/icons/user.svg'" alt="User Image | Luminous">
            <img loading="lazy" width="21" height="21" id="userImgHover" class="userImgHover" [src]="environment?.blobUrl+'/assets/icons/userBlue.svg'"
              alt="UserImg | Luminous" (click)="navigateToSignIn()">
            <ul class="items-main" [ngClass]="{'showList':showDropDownList}">
              <app-profile-sidebar [notShowActiveClass]="true" (routeSet)="dropdownListHandler($event)">
              </app-profile-sidebar>
            </ul>
          </div>
          <div class="icon-col" [routerLink]="['/cart-details']">
            <img width="21" height="21" class="userImg" (click)="analyticsService.triggerCartViewed()"
             loading="lazy" [src]="environment?.blobUrl+'/assets/icons/cart.svg'" alt="Cart | Luminous">
            <!-- <span *ngIf="service.cartData$ | async as cartInfo" class="item-number">{{cartInfo.length || ''}}</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="lowerContainer">
      <a class="heading5 fw-bold" [routerLink]="['/about-us']">About Us</a>
      <a class="heading5 fw-bold" [routerLink]="['/global-presence']">global presence</a>
      <a class="heading5 fw-bold" [routerLink]="['/enquiry']">Business Enquiry</a>
      <a class="heading5 fw-bold" [routerLink]="['/customer-support']">support</a>
      <a class="heading5 fw-bold" [routerLink]="['/catalogue']">catalogue</a>
      <a class="heading5 fw-bold" [routerLink]="['/career']">careers</a>
    </div>
  </div>
</div>
